<template>
  <div class="rating">
    <label>
      <input type="radio" name="stars" value="1" v-model="inputVal">
      <span class="icon">★</span>
    </label>
    <label>
      <input type="radio" name="stars" value="2" v-model="inputVal">
      <span class="icon">★</span>
      <span class="icon">★</span>
    </label>
    <label>
      <input type="radio" name="stars" value="3" v-model="inputVal">
      <span class="icon">★</span>
      <span class="icon">★</span>
      <span class="icon">★</span>
    </label>
    <label>
      <input type="radio" name="stars" value="4" v-model="inputVal">
      <span class="icon">★</span>
      <span class="icon">★</span>
      <span class="icon">★</span>
      <span class="icon">★</span>
    </label>
    <label>
      <input type="radio" name="stars" value="5" v-model="inputVal">
      <span class="icon">★</span>
      <span class="icon">★</span>
      <span class="icon">★</span>
      <span class="icon">★</span>
      <span class="icon">★</span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'ratingField',
  props: ['value'],
  data () {
    return { inputVal: this.value }
  },
  watch: {
    inputVal (val) {
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="css" scoped>
.rating {
  display: inline-block;
  position: relative;
  height: 50px;
  line-height: 50px;
  font-size: 50px;
}

.rating label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  cursor: pointer;
}

.rating label:last-child {
  position: static;
}

.rating label:nth-child(1) {
  z-index: 5;
}

.rating label:nth-child(2) {
  z-index: 4;
}

.rating label:nth-child(3) {
  z-index: 3;
}

.rating label:nth-child(4) {
  z-index: 2;
}

.rating label:nth-child(5) {
  z-index: 1;
}

.rating label input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.rating label .icon {
  float: left;
  color: transparent;
  margin-right: 0.35em;
}

.rating label:last-child .icon {
  color: #c3c3c3;
}

.rating:not(:hover) label input:checked ~ .icon,
.rating:hover label:hover input ~ .icon {
  color: #09f;
}

.rating label input:focus:not(:checked) ~ .icon:last-child {
  color: #c3c3c3;
  text-shadow: 0 0 5px #09f;
}
</style>
